export const toTitleCase = value => {
  if (!value) return "";
  value = value.toString().replace(/-/g, " ");
  return value.charAt(0).toUpperCase() + value.slice(1);
};
